import React from 'react';
import { Avatar } from '@planne-software/uni/Avatar';

import { ReservationRow, ReservationRowText } from '../styles';

export type ReservationSupplierRowProps = {
  name: string;
  logoUrl: string | null;
};

export const ReservationSupplierRow = (props: ReservationSupplierRowProps) => {
  const { name, logoUrl } = props;

  return (
    <ReservationRow data-testid='reservation-supplier'>
      {logoUrl ? <Avatar size='mini' src={logoUrl} alt={name} /> : null}
      <ReservationRowText>{name}</ReservationRowText>
    </ReservationRow>
  );
};

export default ReservationSupplierRow;
